import React, { useState, useEffect, useContext } from "react";
import { navigate, withPrefix } from "gatsby";

import { firstUpperOnly } from "../../../shared/utils/stringUtilities";
import { GigyaAccount } from "../../../shared/interfaces/GigyaAccount";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import GlobalContext from "../../../contexts/globalContext";
import { setCollectionToken } from "../../../services/token";

import "./login.scss";

interface LoginInterface {
  title: string;
  isMenuActive?: boolean;
  login: () => void;
  logout: () => void;
  updateProfile: () => void;
  gigyaAccount?: GigyaAccount;
}

const Login = (props: LoginInterface) => {
  const { isBrowser, document, window } = useBrowserMode();
  const [isShow, setIsShow] = useState(false);
  const context = useContext(GlobalContext);
  const gigyaAccount = props.gigyaAccount;

  useEffect(() => {
    if (gigyaAccount?.UID) {
      setCollectionToken(gigyaAccount.UID).then(() => {
        localStorage.setItem("uid", gigyaAccount.UID);
      });
      context.gigyaUid?.set(gigyaAccount.UID);
    } else {
      context.gigyaUid?.set("");
    }
  }, [gigyaAccount]);

  const upperOptions = [
    {
      title: "Ir a mi perfil",
      icon: "icon-user-circle1",
      gtm: "gtmMenuTransPerfilUsuarioIrAMiPerfil",
      onAction: () => {
        doShow(false);
        props.updateProfile();
      },
    },
    {
      title: "Mis préstamos",
      icon: "icon-tv",
      gtm: "gtmMenuTransPerfilUsuarioLibrosDigitales",
      onAction: () => {
        if (isBrowser) {
          doShow(false);
          // window.open("https://comfama.overdrive.com/account/loans", "_blank");
          navigate("/mis-libros-digitales/")
        }
      },
    },
    {
      title: "Estado de mi cuenta",
      icon: "icon-book",
      gtm: "gtmMenuTransPerfilUsuarioLibrosRenovaciones",
      onAction: () => {
        if (isBrowser) {
          doShow(false);
          window.open(
            "https://comfama.primo.exlibrisgroup.com/discovery/account?vid=57COMFAMA_INST:57COMFAMA&section=loans&lang=es",
            "_blank"
          );
        }
      },
    },
  ];

  const lowerOptions = [
    {
      title: "Cerrar sesión",
      gtm: "gtmMenuTransPerfilUsuarioCerrarSesion",
      onAction: () => {
        props.logout();
        doShow(false);
        setCollectionToken("", false);
        localStorage.removeItem("uid");
        localStorage.removeItem("uidToken");
        localStorage.removeItem("overdriveToken");
        if (window.location.pathname.slice(0, -1) === withPrefix("mis-libros-digitales"))
          window.location.replace(withPrefix("/"))
      },
    },
  ];

  const doShow = (isShow: boolean) => {
    if (isBrowser && isShow) {
      const querySelector = document.querySelector("body");
      querySelector?.classList.add("freeze-page");
    } else if (isBrowser) {
      const querySelector = document.querySelector("body");
      querySelector?.classList.remove("freeze-page");
    }
    setIsShow(isShow);
  };

  return (
    <div className="a-login">
      {gigyaAccount ? (
        <div
          className={`a-login__container ${
            props.isMenuActive ? "a-login__container-open" : ""
          }`}
        >
          <span className="a-login__container__title hide-mobile">
            {`¡Hola ${firstUpperOnly(
              gigyaAccount.profile.firstName
            )} ${firstUpperOnly(gigyaAccount.profile.lastName)}!`}
          </span>
          <i
            className={`a-login__container__icon ${
              isShow ? "icon-caret-down up" : "icon-caret-down"
            } hide-mobile gtmMenuTransPerfilUsuario`}
            onClick={() => doShow(!isShow)}
          />
          <div
            className={`a-login__container__circle 
                  ${isShow ? "a-login__container__circle-open" : ""} 
                  ${
                    gigyaAccount.profile?.gender === "f"
                      ? "circle-female"
                      : gigyaAccount.profile?.gender === "m"
                      ? "circle-male"
                      : ""
                  }  gtmMenuTransPerfilUsuario`}
            onClick={() => doShow(!isShow)}
          >
            {gigyaAccount.profile?.thumbnailURL ? (
              <div className="a-login__container__circle__cover gtmMenuTransPerfilUsuario">
                <img
                  className="a-login__container__circle__cover__img gtmMenuTransPerfilUsuario"
                  alt={gigyaAccount.profile.firstName}
                  src={gigyaAccount.profile.thumbnailURL}
                />
              </div>
            ) : (
              `${gigyaAccount.profile?.firstName.charAt(
                0
              )}${gigyaAccount.profile?.lastName.charAt(0)}`
            )}
          </div>
          {isShow && (
            <div className="a-login__container__float-box">
              <ul className="a-login__container__float-box__options">
                {upperOptions.map((value, index) => (
                  <li
                    onClick={value.onAction}
                    className={`a-login__container__float-box__options__option ${value.gtm}`}
                    key={`floatBoxOption-${index}`}
                  >
                    <i
                      className={`a-login__container__float-box__options__option__icon ${value.icon} ${value.gtm}`}
                    />
                    {value.title}
                  </li>
                ))}
                <li className="a-login__container__float-box__options separator" />
                {lowerOptions.map((value, index) => (
                  <li
                    onClick={value.onAction}
                    className={`a-login__container__float-box__options__option ${value.gtm}`}
                    key={`floatBoxOption-${index}`}
                  >
                    {value.title}
                  </li>
                ))}
              </ul>
              <div
                className="a-login__container__float-box__background"
                onClick={() => doShow(false)}
              ></div>
            </div>
          )}
        </div>
      ) : (
        <>
          <i
            className={`a-login__icon icon-user hide-desktop gtmMenuTransIniciarSesion`}
            onClick={props.login}
          />
          <span
            className={`a-login__title hide-mobile ${
              props.isMenuActive ? "a-login__title-open" : ""
            } gtmMenuTransIniciarSesion`}
            onClick={props.login}
          >
            {props.title}
          </span>
        </>
      )}
    </div>
  );
};

export default Login;
